import React, { useState, useRef, useEffect } from "react";
import "./EditTaskGroup.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";
import { useTranslation } from "react-i18next";

function EditTaskGroup({
  taskGroupData,
  updateTaskGroup,
  cancelEditTaskGroup,
}) {
  const { t } = useTranslation();
  const [name, setName] = useState(taskGroupData?.name || "");
  const [selectedColor, setSelectedColor] = useState(
    normalizeColor(taskGroupData?.color),
  );
  const [showNameError, setShowNameError] = useState(false);

  // Update state when taskGroupData changes
  useEffect(() => {
    if (taskGroupData) {
      setName(taskGroupData.name || "");
      setSelectedColor(normalizeColor(taskGroupData.color));
    }
  }, [taskGroupData]);

  const handleUpdateTaskGroup = () => {
    if (name.trim()) {
      const colorHex = normalizeColor(selectedColor);
      updateTaskGroup(taskGroupData._id, name.trim(), colorHex);
      setShowNameError(false);
    } else {
      setShowNameError(true);
    }
  };

  // Set focus on input field when modal opens
  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select(); // Select all text for easy editing
      }
    }, 100); // 100ms delay to ensure DOM is ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="edit-task-group-content">
      <div className="modal-title">
        <div>{t("tasks.modals.editTaskGroup.title")}</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">{t("common.name")}</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder={t("tasks.modals.editTaskGroup.namePlaceholder")}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (showNameError && e.target.value.trim()) {
              setShowNameError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleUpdateTaskGroup();
            }
          }}
        />
        {showNameError && (
          <div className="modal-helper-text">
            {t("tasks.group.nameRequired")}
          </div>
        )}

        <div className="modal-form-title">{t("common.color")}</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>
        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              cancelEditTaskGroup();
            }}
          >
            {t("common.cancel")}
          </button>
          <button className="modal-button save" onClick={handleUpdateTaskGroup}>
            {t("common.update")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditTaskGroup;
